import { render, staticRenderFns } from "./fiatcurrency-edit.vue?vue&type=template&id=b8abcf38&"
import script from "./fiatcurrency-edit.vue?vue&type=script&lang=js&"
export * from "./fiatcurrency-edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports